import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { SearchFilters } from '../routes/AvailabilityGuard';

export interface UseOpenParametersUrlNormalizationOptions {
	searchFilters: SearchFilters;
}

const FILTER_KEYS = ['groupSize', 'date', 'time'] as const;

/**
 * The results page only renders meaningful availability with all three parameters
 * set. A URL carrying a partial set (one or two of them) is dropped back to none,
 * so the page shows the unset-parameters empty state rather than a half-applied search.
 */
export function useOpenParametersUrlNormalization({ searchFilters }: UseOpenParametersUrlNormalizationOptions) {
	const [searchParams, setSearchParams] = useSearchParams();
	const location = useLocation();

	useEffect(() => {
		if (!location.pathname.endsWith('/explore')) {
			return;
		}

		const setCount =
			(searchFilters.groupSize ? 1 : 0) +
			(searchFilters.date ? 1 : 0) +
			(searchFilters.time ? 1 : 0);

		if (setCount === 0 || setCount === 3) {
			return;
		}

		const next = new URLSearchParams(searchParams);
		for (const key of FILTER_KEYS) {
			next.delete(key);
		}
		setSearchParams(next, { replace: true });
	}, [
		location.pathname,
		searchFilters.groupSize,
		searchFilters.date,
		searchFilters.time,
		searchParams,
		setSearchParams
	]);
}
